import { type LucideIcon, MessageSquarePlus } from 'lucide-react';

export const RichTextIcon: LucideIcon = MessageSquarePlus;
